const personality = [
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向是罗曼蒂克，且富想象力的',t:"E"},
      {a:'我一向是很实际的',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我喜欢与人对立',t:"G"},
      {a:'我有避免与人对立的倾向',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向是典型富外交手腕的，吸魅力，且有野心',t:"C"},
      {a:'我的性格一向是典型的直率且理想化',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向是专注且具有高度热忱',t:"H"},
      {a:'我一向是很自发的、喜欢好玩乐的',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向是友善热情且欢迎朋友加入我的生活',t:"F"},
      {a:'我一向是个注重稳私的人，不太和别人的生活有所重叠',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，招惹我、使我脾气暴躁是一件容易的事',t:"B"},
      {a:'大体而言，招惹我、使我脾气暴躁是一件困难的事',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我是个机灵的丛林生存者',t:"G"},
      {a:'我是个品格高尚的理想主义者',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向需要对他人表达热情',t:"F"},
      {a:'我倾向和他人保持一定的距离',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面对全新的经验时，我通常会自问这对我是否有用处',t:"C"},
      {a:'面对全新的经验时，我通常会自问这是否有趣',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我有过分将焦点放在自己身上的倾向',t:"E"},
      {a:'我有过分将焦点放在他人身上的倾向',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'他人一向很依赖史的洞察力及知识',t:"H"},
      {a:'他人一向很依赖我的坚强及果断',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向对自己很没信心',t:"B"},
      {a:'我一向对自己太有信心',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向较重视人际关系，而非以目标为导向',t:"F"},
      {a:'我一向较重视目标导向，而非人际关系为重',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一直无法清楚地表达自我',t:"E"},
      {a:'我一向坦白直言——我说了许多他人希望自己有胆量说出的话',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'不左右评估各种选择性而立即采取明确的行动，对我而言是极困难的',t:"H"},
      {a:'纵容应付事情且增加自己的弹性，对我而言是困难的',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我有犹豫不决、拖泥带水的倾向',t:"B"},
      {a:'我向来十分大胆且跋扈专权',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'不愿过分与人交往已造成我交友上的困难',t:"A"},
      {a:'过分需要朋友依赖我已造成我交友上的困难',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常能够置个人感情于一旁而将工作完成',t:"C"},
      {a:'我通常必须感情活络起来才能开始工作',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我是有条理且审慎的',t:"B"},
      {a:'大体而言，我是好刺激且愿意冒险的',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来是愿意支持他人，为他人付出，喜欢有人为伴的',t:"F"},
      {a:'我向来是严肃的、克制的、喜欢讨论问题',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常觉得自己有必要扮演“力量支柱”角色',t:"G"},
      {a:'我常觉得有必要表现得完美无缺',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我喜欢提出困难的问题，以及维持自己的独立性',t:"H"},
      {a:'我喜欢维持稳定性信心中的平静',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向太顽固多疑',t:"B"},
      {a:'我一向太心软且滥情',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向担心自己错过好的东西',t:"I"},
      {a:'我一向担心自己放松武装，别人可能会占我便宜',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我矜持冷淡的习惯向来令人不悦',t:"E"},
      {a:'我那指挥别人的习惯向来令人不悦',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面临麻烦时,我有能力将之解决',t:"A"},
      {a:'面临麻烦时，我会以自己喜欢的东西慰劳自己',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来依赖我的朋友，面朋友也知道他的可以依赖我',t:"B"},
      {a:'我从不依赖朋友，我向来靠自己完成任何事情',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我倾向于超然的、坚定不移的态度',t:"H"},
      {a:'我倾向于情绪化、专注于自己利益的态度',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我喜欢向别人挑战，动摇他们的态度',t:"G"},
      {a:'我喜欢安慰别人，使他们冷静下来',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我是个外向的、擅社交的人',t:"I"},
      {a:'大体而言，我是个认真的、自律的人',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常羞于表现我的能力',t:"A"},
      {a:'我通常喜欢让他人知道我擅长做的事',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'追求个人兴趣对我而言比拥有舒适及安全感更重要',t:"H"},
      {a:'拥有舒适及安全感对我而言比追求个人兴趣更重要',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'一旦与人发生冲突，我倾向于撤离',t:"E"},
      {a:'一旦与人发生冲突，我很少退让',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我太容易付出自已，因此被他人摆布',t:"A"},
      {a:'我太顽固、不妥协、对人要求过多',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'他人向来欣赏我坚持的精神及高度的幽默感',t:"I"},
      {a:'他人向来欣赏我恬静的实力及雅量',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我的成就大多来自我给人制造的好印象的能力',t:"C"},
      {a:'尽管我对发展社交技巧不甚感兴趣，却也无碍于我的成就',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我很以自己的毅力及常识为傲',t:"B"},
      {a:'我很以自己的确创新、创造力为傲',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'基本上，我一向是随遇而安、平易近人',t:"A"},
      {a:'基本上，我一向是吹毛求疵、武断',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我很努力使自己被接受，被喜欢',t:"C"},
      {a:'对我而言，被接受和被喜爱并非第一目标',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面对来自别人的压力，我常变得更缄默',t:"H"},
      {a:'面对来自别人的压力，我常变得更积极',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'人们因为我外向，引人注意、对他们表现兴趣的个性而对我很感兴趣',t:"F"},
      {a:'人们因为我有沉静、独特及深沉而对我感到兴趣',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'义务与责任对我而言是重要的',t:"B"},
      {a:'和谐与认同对我而言是重要的',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向以大计划和承诺来推动他人',t:"G"},
      {a:'指出不听从我意见的后果是我推动别人的方法',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我很少表现情绪化',t:"H"},
      {a:'我常表现情绪化',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'细节处理并非我的专长',t:"I"},
      {a:'我一向以注意细节取胜',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常强调自己和朋友之间的不同',t:"E"},
      {a:'我常强调自己和朋友之间的共同点',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'当情况转为白热化，我会倾向加入其中',t:"G"},
      {a:'当情况转为白热化，我会倾向旁观',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来会为朋友挺身而出，即使他们是错的',t:"B"},
      {a:'我不想为了友谊而颠倒是非',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来是个善意的支持者',t:"F"},
      {a:'我向来是个积极主动的追求者',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面对困扰时，我会陷在里面',t:"E"},
      {a:'面对困扰时，我会想办法放轻松',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我信心坚定，知道事情该怎么处理',t:"D"},
      {a:'大体而言，我很多虑，对周遭的事情没有什么把握',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'因为我的过分悲观及好抱怨，我和他人之间的相处遂产生一些问题',t:"B"},
      {a:'因为我的霸气及强烈控制欲，我与他人之间的相处遂产生一些问题',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我倾向依感觉行事，任何事物自然发展',t:"F"},
      {a:'我倾向不依感觉行事，以免感觉引起更多的问题',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我认为身为注意力的焦点是极自然的',t:"C"},
      {a:'我认为身为注意力的焦点是很奇怪的',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来很小心，对无法预期的问题也有心里准备',t:"B"},
      {a:'我向来很即兴，宁可有问题发生时临时准备应付之道',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'当别人未对我的协助表示足够的感激时，我会十分愤怒',t:"F"},
      {a:'当别人未听从我告诉他们的话时，我会十分愤怒',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'独立与自主对我而言是重要的',t:"G"},
      {a:'受别人重视及称赞对我而言是重要的',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'和朋友争论时，我会强力坚持我的论点',t:"H"},
      {a:'和朋友争论时，我会努力避免伤和气',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常会强烈占有所爱的人——我无法任他们发展自大我',t:"E"},
      {a:'我常会试探所爱的人，看他们是否会在我需要他们时全力支援我',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我的主要长处之一是利用资源及实现计划',t:"G"},
      {a:'我的主要长处之一是提出新点子，使人们为之兴奋',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向对自己要求甚高',t:"D"},
      {a:'我一向太情绪化且缺乏纪律',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一直努力使自己的生活步调加快密集且刺激',t:"I"},
      {a:'我一直努力使自己的生活规律、稳定且平和',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'放弃过去的承诺令我不安，因此我不太能接受生活上的重大改变',t:"B"},
      {a:'做长期的承诺会令我不安，因此我较能接受生活上的重大改变',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常专注于自己情感，且喜欢让它一直持续下去',t:"E"},
      {a:'我通常会淡化自己的情感，不会太注意它',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我已提供许多人关怀与教养',t:"F"},
      {a:'我已提供许多人方向与诱因',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我对自己向来太严肃且严格',t:"D"},
      {a:'我对自己向来太放任且宽容',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来自信且好胜',t:"C"},
      {a:'我向来谦卑且乐于以自己喜爱的步调行事',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来以自己的清晰与客观为傲',t:"H"},
      {a:'我向来以自己的可靠性与承诺为傲',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我花了许多精力内省——了解自我对我而言是重要的',t:"F"},
      {a:'我并未花费许多时间内省——完成事物对我而言才是重要的',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来认为自己是个愉快的、随和的人',t:"A"},
      {a:'我向来认为自己是个严肃的、高贵的人',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我拥有灵敏的心思与无穷的精力',t:"I"},
      {a:'我拥有关怀的心与奉献的精神',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来从事上些可能导致回馈或他人的认可的活动',t:"C"},
      {a:'如果是我有兴趣的活动，我倒不在乎回馈可他人的认可',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'完成社会责任从未在我的活动顺位中占有重要的地位',t:"F"},
      {a:'我向来重视我的社会责任',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'在许多状况下，我宁可采取领导的姿态',t:"G"},
      {a:'在许多状况下，我宁可让他人占据领导的地位',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'在过去的几年里，我的生活型态与价值观念已有多次的改变',t:"C"},
      {a:'在过去的几年里，我的生活型态与价值观念大致保持原状',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'很典型地，我一直没有太多的自律能力',t:"I"},
      {a:'很典型地，我一直和人们没有太多的关连',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一直觉得自己感情太容易受伤害，所以无法与人相处',t:"E"},
      {a:'我一直觉得自己的牺牲奉献被认为是所当然的',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我有对事物做最坏打算的倾向',t:"B"},
      {a:'我倾向相信事物终究会有最好的发展结果',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'人们信赖我，因为我有自信且能够为他们着想',t:"G"},
      {a:'人们信赖我，因为我很公正且会何等正确的事',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我时常因过分专注于自己的计划而与他人疏离',t:"H"},
      {a:'我时常因过分融入他人的世界机时忽略了自己的计划',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面对新朋友时，我常会表现得沉默寡言、不易冲动',t:"C"},
      {a:'面对新朋友是，我常会变得健谈、风趣',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我有悲观的倾向',t:"E"},
      {a:'大体而言，我有东观的倾向',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我喜欢生活在自己的小世界里',t:"H"},
      {a:'我喜欢让整个世界知道我的存在',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常受紧张、不安全感及疑虑的困扰',t:"B"},
      {a:'我常受愤怒、理想主义及缺乏耐性的困扰',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我知道自己常表现得太亲密且涉及隐私',t:"F"},
      {a:'我知道自己常表现得太冷淡且疏远',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我已被取而代之，因为我没有把握机会',t:"E"},
      {a:'我已被取而代之，因为我一次追求太多机会',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来需要一段较长的时间来准备行动',t:"H"},
      {a:'我向来能很快地开始行动',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'做决定对我而言通常很困难',t:"B"},
      {a:'做决定对我而言很少有困难',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我有对人过分强势的倾向',t:"F"},
      {a:'我有避免坚持已见的倾向',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我已经尽力去和人接触、建立人际关系',t:"C"},
      {a:'大体而言，我尚未尽力去和人接触、建立人际关系',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'当我不知怎么办时，我通常会向人询问意见',t:"B"},
      {a:'当我不知怎么办时，我会尝试不同的何等法，看看哪一种较有效',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来担心别人会忘了邀请我参加活动',t:"F"},
      {a:'我向来担心别人的活动会让我分心',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'通常当我生气时，我会斥责他人',t:"G"},
      {a:'通常当我生气时我会变得很冷淡',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来有不易入睡的困扰',t:"H"},
      {a:'我向来能轻易入睡',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我很希望知道与人亲近的方法',t:"F"},
      {a:'我很希望知道别人想由我身上得到什么',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常比较审慎、坦诚、体贴',t:"G"},
      {a:'我通常比较活泼、多嘴、机智',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'通常在见到别人犯错误时，我会保持沉默',t:"E"},
      {a:'通常我会帮助别人发现他们正在犯错',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'在我一生中的大部分时间里，我是个感情激烈的人，常有反复无常的情绪',t:"I"},
      {a:'在我一生中的大部分时间里，我是个事情稳定的人，情绪与思虑深沉且平静',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我若讨厌某些人，我还是会不顾自己的感觉尽量以热忱待之',t:"C"},
      {a:'我若讨厌某些人，我会想办法让他们知道',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我与别人之间的相处，困难太多起因于我太敏感，凡事太当真',t:"E"},
      {a:'我与别人之间的相处，困难太多起因于我不在乎社交礼俗',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我的办法是跳进去把人救出来',t:"F"},
      {a:'我的办法是告诉别人如何自助',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我一向喜欢放手去发挥且突破限制',t:"I"},
      {a:'大体而言，我一向不太喜欢失去自我控制',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我太在意自己应比别人强',t:"C"},
      {a:'我太在意自己应帮助别人解决困难',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'由于想象力及好奇心，我的想法一向很有冒险性',t:"H"},
      {a:'我的想法一向很实际，只尝试着推动事物',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我主要的长处之一是主导各种情况的能力',t:"G"},
      {a:'我主要的长处之一是描述内在状态的能力',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向催促事物的完成，尽管这样的做法令他人不舒坦',t:"D"},
      {a:'我一向不喜欢受开幕以压力，因此我也不施压于别人',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来以自己在别人生活中所扮演的重要角色为傲',t:"F"},
      {a:'我向来以自己的风趣及对新事物的开放态度为傲',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我可以感觉到别人认为我是适于出现于公开场合的，甚至是值得欣赏的',t:"C"},
      {a:'我可以感觉到别人认为我是奇特的，甚至是怪异的',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我几乎完成了所有我该做的事',t:"B"},
      {a:'我几乎完成了所有我想做的事',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常能享受压力大的，甚至困难的状况',t:"G"},
      {a:'我通常讨厌压力大的，甚至困难的状况',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向以自己的弹性为傲——所谓适当或重要的定义是多变的',t:"C"},
      {a:'我一向以自己坚定的立场为傲——我坚持自己信仰的事物',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我的风格倾向于节省朴实',t:"H"},
      {a:'我的风格倾向于无节制，做过头',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我的健康及幸福因我强烈的助人欲机时受害',t:"F"},
      {a:'我的人际关系因我强烈的私欲而受害',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我太开放、天真',t:"A"},
      {a:'大体而言，我太机警、谨慎',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'有时我因太积极而妨碍了他人',t:"G"},
      {a:'有时我因太保守而妨碍了他人',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'服务他人、因应他人的需求，对我而言是重要的',t:"F"},
      {a:'寻求对待事物和做事的各种方法，对我而言是重要的',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'很典型地，我是个脾气稳定的人',t:"C"},
      {a:'很典型地，我的情绪向来会有强烈的变化',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'通常能引起剧烈情绪震荡的情况都会吸引我',t:"E"},
      {a:'通常令我觉得平静、舒适的情况能会吸引我',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来较在乎追求自己的兴趣，而非得到实际的结果',t:"U"},
      {a:'我向来很实际，且期待自己的努力能得到具体的成果',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我有强烈的归属需求',t:"B"},
      {a:'我有强烈的平衡需求',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'过去我可能在交友上过于坚持亲密性',t:"F"},
      {a:'过去我可能在交友上保持太多的距离',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常会想过去的事',t:"E"},
      {a:'我常会期待将要做的事',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我倾向认为人是没有组织性的、不负责任的',t:"D"},
      {a:'我倾向认为人是有侵略性的、索求无度的',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我对自己不是很有信心',t:"B"},
      {a:'大体而言，我只对自己有信心',t:'G'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我或许一直都太被动、不够投入',t:"A"},
      {a:'我或许一直都有太强的支配欲和操纵欲',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我常会因自己的疑虑而中止行事',t:"E"},
      {a:'我很少让自己的疑虑妨碍行事',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面临熟悉的东西和新事物时，我通常会选择新事物',t:"I"},
      {a:'我通常会选择我确定自己会喜欢的东西：为何要选择自己可能不喜欢的东西来令自己失望',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我会会使用肢体接触来表达我对他人的感觉',t:"F"},
      {a:'我一向认为真爱不须以肢体接触来表达',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'必要与人对立时，我通常会表现得太严厉、太直接',t:"G"},
      {a:'必要与人对立时，我通常会过分兜圈子（不直接谈正题）',t:'C'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我向来对可能困扰别人或吓着别人的主题有兴趣',t:"H"},
      {a:'我宁可不把时间花费在扰人、吓人的主题上',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我因过于侵扰及干预别人而产生人际关系的困扰',t:"F"},
      {a:'我因过于逃避及沉默而产生的人际关系困扰',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我担心自己没有足够的资源可以完成所承担的责任',t:"G"},
      {a:'我担心自己没有足够的自制力来实践自己',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'整体而言，我一直是凭直觉的、个人主义的',t:"E"},
      {a:'整体而言，我一直是非常有组织力的、负责任的',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'克服惰性一向是我的主要课题',t:"A"},
      {a:'无法放慢脚步一向是我的主要问题',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'一旦觉得没有安全感，我的反应是变得傲慢、排斥',t:"C"},
      {a:'一旦觉得没有安全感，我的反应是起而防卫、辩护',t:'B'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'大体而言，我向来是开放的、愿意尝试新事物的',t:"H"},
      {a:'大体而言，我向来喜欢自我表白，和别人分享我的感觉',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'面对他人时，我通常会表现得比原来的自己更坚强',t:"G"},
      {a:'面对他人时，我通常会表现得比原来的自己更具关怀心',t:'F'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我通常会依循自己的良知与理性行事',t:"D"},
      {a:'我通常会依循自己的感觉与冲动行事',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'愈严重的逆境只会让我更坚强,更刚毅',t:"C"},
      {a:'愈严重的逆境会让我受挫折且退缩',t:'A'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向确信自己拥有一个安全的窝可以依靠',t:"B"},
      {a:'我一向选择尽量不倚赖任何事物',t:'H'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我必须为别人而表现坚强，因此我没有时间处理自己的感觉及恐惧',t:"G"},
      {a:'我无法处理自己的感觉及恐惧，因此我不能为别人而表现坚强',t:'E'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向不懂，为何人们在面对生命中这么多的有趣事物昌，仍旧会将注意力集中在负面的事物上',t:"A"},
      {a:'我一向无法理解，为何人们在生活一团糟时，仍能表现得如此快乐',t:'D'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'我一向努力使自己不被认为是个自私的人',t:"F"},
      {a:'我一向努力使自己不被认为是个无趣的人',t:'I'},
    ]
  },
  {
    title:'请选出一项符合你的答案',
    an:[
      {a:'当我害怕自己会无法处理别人需求时，我会避免亲密的接触',t:"H"},
      {a:'当我害怕自己无法满足他人的期望时，我会避免亲密的接触',t:'C'},
    ]
  }
]
export default personality